import React, { useState } from 'react';
import { CashinFilter } from './components/AccountingFilter';
import CashinReport from './components/CashinReport';
import Frame from './components/Frame';
import Home from './components/Home';

function AccountingApp() {
  const [toggleKey, setToggleKey] = useState(0);
  return (
    <Frame.Base>
      {toggleKey === 0 && <Home setToggle={setToggleKey} />}

      {toggleKey === 2 && (
        <>
          <CashinFilter />
          <CashinReport />
        </>
      )}
    </Frame.Base>
  );
}

export default AccountingApp;
